'use strict';

require.config({
    map: {
        '*': {
            'ie8css': 'https://cdn.sinooceangroup.com/libs/requirecss-branch-seagull2/1.1.0/ie8css.min.js',
            'css': 'https://cdn.sinooceangroup.com/libs/requirecss-branch-seagull2/1.1.0/css.min.js'
        }
    },
    waitSeconds: 0,
    //配置angular的路径
    paths: {
        'angular': 'https://cdn.sinooceangroup.com/libs/angular/1.2.32/angular.min',
        'angular-cookies': 'https://cdn.sinooceangroup.com/libs/angular-cookies/1.2.32/angular-cookies.min',
        'angular-ui-router': 'https://cdn.sinooceangroup.com/libs/angular-ui-router/0.2.18/release/angular-ui-router.min',
        'angular-ui-tree': 'https://cdn.sinooceangroup.com/libs/angular-ui-tree/2.15.0/dist/angular-ui-tree.min',
        'angular-async-loader': 'https://cdn.sinooceangroup.com/libs/angular-async-loader/1.3.2/angular-async-loader.min',

        'jquery': 'https://cdn.sinooceangroup.com/libs/jquery/1.12.3/dist/jquery.min',
        'webuploader': 'https://cdn.sinooceangroup.com/libs/webuploader/0.1.9/dist/webuploader.min',
        'urijs': 'https://cdn.sinooceangroup.com/libs/urijs/1.18.0/src',
        'text': 'https://cdn.sinooceangroup.com/libs/text/2.0.15/text.min',
        'linqjs': 'https://cdn.sinooceangroup.com/libs/linq/3.0.8/linq.min',

        'angular-seagull2-common': 'https://cdn.sinooceangroup.com/libs/angular-seagull2-common/1.10.0/angular-seagull2-common.min',
        'angular-seagull2-oauth': 'https://cdn.sinooceangroup.com/libs/angular-seagull2-oauth/1.8.0/angular-seagull2-oauth.min',
        'angular-seagull2-workflow': 'https://cdn.sinooceangroup.com/libs/angular-seagull2-workflow/1.20.1/angular-seagull2-workflow.min',
        'angular-seagull2-infrastructure': 'https://cdn.sinooceangroup.com/libs/angular-seagull2-infrastructure/0.2.4/angular-seagull2-infrastructure.min',
        'angular-datepicker': 'https://cdn.sinooceangroup.com/libs/datepicker-branch-seagull2/1.0.11/datepicker-branch-seagull2.min',

        'app': './javascript/app',
        'app-routes': './javascript/app-routes',
        'encrypt': './javascript/Encrypt',
        'cryptoJS': './javascript/CryptoJS',
        'secret': './javascript/secret',
        'appConstant': './javascript/controllers/common/appConstant',
        'appService': './javascript/controllers/common/appService'
    },
    //这个配置是你在引入依赖的时候的包名
    shim: {
        'angular': { exports: 'angular' },
        'angular-cookies': { exports: 'angular-cookies', deps: ['angular'] },
        'angular-ui-router': { deps: ['angular'] },
        'angular-ui-tree': { deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/angular-ui-tree/2.15.0/dist/angular-ui-tree.min'] },
        'angular-datepicker': { deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/datepicker-branch-seagull2/1.0.11/datepicker-branch-seagull2'] },
        'angular-seagull2-common': {
            deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/angular-seagull2-common/1.10.0/angular-seagull2-common.min', 'ie8css!https://cdn.sinooceangroup.com/libs/angular-seagull2-common/1.10.0/angular-seagull2-common.ie8.min']
        },
        'angular-seagull2-oauth': {
            deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/angular-seagull2-oauth/1.8.0/angular-seagull2-oauth.min', 'ie8css!https://cdn.sinooceangroup.com/libs/angular-seagull2-oauth/1.8.0/angular-seagull2-oauth.ie8.min']
        },
        'angular-seagull2-workflow': {
            deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/angular-seagull2-workflow/1.19.2/angular-seagull2-workflow.min', 'ie8css!https://cdn.sinooceangroup.com/libs/angular-seagull2-workflow/1.19.2/angular-seagull2-workflow.ie8.min']
        },
        'angular-seagull2-infrastructure': {
            deps: ['angular', 'css!https://cdn.sinooceangroup.com/libs/angular-seagull2-infrastructure/0.2.4/angular-seagull2-infrastructure.min', 'ie8css!https://cdn.sinooceangroup.com/libs/angular-seagull2-infrastructure/0.2.4/angular-seagull2-infrastructure.ie8.min']
        },
        'angular-seagull2-bankprovider': {
            deps: ['angular', 'angular-seagull2-common', 'angular-seagull2-workflow', 'css!https://cdn.sinooceangroup.com/libs/angular-seagull2-infrastructure/0.2.4/angular-seagull2-infrastructure.min', 'ie8css!https://cdn.sinooceangroup.com/libs/angular-seagull2-infrastructure/0.2.4/angular-seagull2-infrastructure.ie8.min']
        },
        'appConstant': { deps: ['angular'] },
        'appService': { deps: ['angular', 'angular-seagull2-common', 'appConstant'] },
        'encrypt': { deps: ['angular'] }
    }
});

require(['angular', 'app', 'app-routes', 'cryptoJS', 'secret'], function (angular, app) {
    angular.element(document).ready(function () {
        angular.bootstrap(document, ['app']);
        angular.element(document).find('html').addClass('ng-app');
        window.sogFormBridge = app.get('sogFormBridge');
    });
});